import React from "react";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

const normalizeOptions = (options) => Array.isArray(options)
  ? options.map((option) => ({
      id: String(option?.id || ""),
      text: String(option?.text || ""),
    }))
  : [];

const QuestionFormMultipleChoice = ({ value, onChange }) => {
  const question = value || {};
  const options = normalizeOptions(question.options);
  const correctAnswers = Array.isArray(question.correctAnswers)
    ? question.correctAnswers.map(String)
    : [];

  const updateOption = (index, patch) => {
    const previousId = options[index]?.id;
    const nextOptions = options.map((option, optionIndex) => (
      optionIndex === index ? { ...option, ...patch } : option
    ));
    const nextCorrectAnswers = patch.id !== undefined && correctAnswers.includes(previousId)
      ? correctAnswers.map((id) => (id === previousId ? patch.id : id))
      : correctAnswers;
    onChange({ ...question, options: nextOptions, correctAnswers: nextCorrectAnswers });
  };

  const removeOption = (index) => {
    const removedId = options[index]?.id;
    onChange({
      ...question,
      options: options.filter((_, optionIndex) => optionIndex !== index),
      correctAnswers: correctAnswers.filter((id) => id !== removedId),
    });
  };

  const toggleCorrect = (id) => {
    const next = correctAnswers.includes(id)
      ? correctAnswers.filter((answer) => answer !== id)
      : [...correctAnswers, id];
    onChange({ ...question, correctAnswers: next });
  };

  return (
    <Stack spacing={2}>
      <TextField
        label="Підзаголовок"
        value={question.subtitle || ""}
        onChange={(event) => onChange({ ...question, subtitle: event.target.value })}
        fullWidth
      />
      <TextField
        label="Питання (HTML)"
        value={question.question || ""}
        onChange={(event) => onChange({ ...question, question: event.target.value })}
        multiline
        minRows={3}
        fullWidth
      />
      <Typography variant="subtitle2">Варіанти відповіді (позначте всі правильні)</Typography>
      {options.map((option, index) => (
        <Stack key={index} direction={{ xs: "column", sm: "row" }} spacing={1} alignItems="center">
          <FormControlLabel
            control={(
              <Checkbox
                checked={Boolean(option.id) && correctAnswers.includes(option.id)}
                onChange={() => toggleCorrect(option.id)}
                disabled={!option.id}
              />
            )}
            label="Правильна"
          />
          <TextField
            label="ID"
            value={option.id}
            onChange={(event) => updateOption(index, { id: event.target.value })}
            sx={{ width: { sm: 110 } }}
          />
          <TextField
            label="Текст варіанта (HTML)"
            value={option.text}
            onChange={(event) => updateOption(index, { text: event.target.value })}
            fullWidth
          />
          <Button color="error" onClick={() => removeOption(index)}>Видалити</Button>
        </Stack>
      ))}
      <Button
        variant="outlined"
        onClick={() => onChange({ ...question, options: [...options, { id: "", text: "" }] })}
      >
        Додати варіант
      </Button>
      {correctAnswers.length < 2 && (
        <Typography color="warning.main" variant="body2">
          Для множинного вибору позначте щонайменше дві правильні відповіді.
        </Typography>
      )}
    </Stack>
  );
};

export default QuestionFormMultipleChoice;
